



































import Vue from 'vue'
import type {Prop} from 'vue/types/options'

interface MenuItem {
  name: string;
  icon: string | null;
  callback: () => void;
}

// dict of menus by name
interface Menus {
  [name: string]: MenuItem[];
}

export default Vue.extend({
  props: {
    menus: {
      type: Object as Prop<Menus>,
      default: () => {/* empty */}
    }
  },
  data() {
    return {
    }
  }
})

